import axios from "axios";
import store from "../redux/store";

import { getCookie, isNull, isHC } from "../shared/helpers";
import { Auth } from "../config/aws-exports";
import { responsesAreSame } from "workbox-broadcast-update";
import ExportTypography from "antd/lib/typography/Typography";
import { alertNotification } from "../components/TopNotification/alertNotification";

const profile = JSON.parse(localStorage.getItem("userProfile"));

const BackendApiBaseUrl = process.env.REACT_APP_API_URL; //REACT_APP_MY_URL
const BackendHubspotAPI = process.env.REACT_APP_SKILLGIGSSUBSCRIBER_URL;

const ADD_TEAM_MEMBER_SCHEMA_KEYS = [
  "EmailAddress",
  "FullName",
  "CompanyName",
  "UserName",
  "JobTitle",
  "PhoneNumber",
  "Source",
];

const pickPayloadKeys = (payload, keys) => {
  if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
    return payload;
  }
  if (typeof FormData !== "undefined" && payload instanceof FormData) {
    return payload;
  }

  const pickedPayload = {};
  keys.forEach((key) => {
    if (payload[key] !== undefined) {
      pickedPayload[key] = payload[key];
    }
  });
  return pickedPayload;
};

const fetchDataUrl = `${BackendApiBaseUrl}/`; //sample
const sendDataUrl = `${BackendApiBaseUrl}/`; //sample
// const getMatchesUrl = `${BackendApiBaseUrl}/empgigs/getmygigmatches`;
const updateProfileUrl = `${BackendApiBaseUrl}/profile`; // need to append /profileId later
// const sendEmailVerifyStatusURL = `${BackendApiBaseUrl}/profile/send-verification-link`;
const sendEmailVerifyStatusURL = `${BackendApiBaseUrl}/send-email-verification-emp`;
const uploadFileUrl = `${BackendApiBaseUrl}/upload`; // need to append /profileId later
const afterUploadTrigger = `${BackendApiBaseUrl}/upload-resume-photo`; // manual trigger after upload to S3
const uploadDPUrl = `${BackendApiBaseUrl}/upload`; // need to append /profileId later
const fetchDocUrl = `${BackendApiBaseUrl}/credentialing/userdoc`;
const uploadDocUrl = `${BackendApiBaseUrl}/document/upload`;
const fetchProfileDetails = `${BackendApiBaseUrl}/profile/me`;
const fetchExistUserUrl = `${BackendApiBaseUrl}/auth/checkUser`;
const passwordlessStartUrl = `${BackendApiBaseUrl}/auth/employer/passwordless/sendOtp`;
const passwordlessConfirmUrl = `${BackendApiBaseUrl}/auth/employer/passwordless/confirmOtp`;
const getSkillsUrl = `${BackendApiBaseUrl}/skill/getSkills`;
const skillListingUrl = `${BackendApiBaseUrl}/skill/listing`;
const fetchProfileExperience = `${BackendApiBaseUrl}/profile/experienceLevels`;
const fetchDeclineReasonsURL = `${BackendApiBaseUrl}/bids/declinedstatus`;
// const createBidUrl = `${BackendApiBaseUrl}/bids/create`;
const createBidUrl = `${BackendApiBaseUrl}/bids/create`;
const createmultiBidUrl = `${BackendApiBaseUrl}/bids/createmulti`;

const updateBidUrl = `${BackendApiBaseUrl}/bids/update`;
// const updateBidUrl = `http://192.168.18.101:5000/production/bids/update`;

const fetchMessagesUrl = `${BackendApiBaseUrl}/message`;
const fetchConversationCountUrl = `${BackendApiBaseUrl}/empprofile/messages/conversationsCounts`;
const checkGapURL = `${BackendApiBaseUrl}/empprofile/contracts/findgap`;

const updateProposalUrl = `${BackendApiBaseUrl}/proposal/recievedBidsByEmp/update`;
//*******************************************Ratings***********************************************

const postRatingUrl = `${BackendApiBaseUrl}/empprofile/ratings/create`;
const putRatingUrl = `${BackendApiBaseUrl}/empprofile/ratings/update`;
const deleteRatingsUrl = `${BackendApiBaseUrl}/empprofile/rating/delete`;

//*******************************************Ratings***********************************************//

//messages new designs*********************************************************************
const getInboxUrl = `${BackendApiBaseUrl}/empprofile/messages/all`;
const getChatHistoryUrl = `${BackendApiBaseUrl}/empprofile/messages/get`;
const sendMessageUrl = `${BackendApiBaseUrl}/message/send`;
const offerAttachment = `${BackendApiBaseUrl}/interview/offer/make`;
const editOfferUrl = `${BackendApiBaseUrl}/interview/offer/update`;
const getRatingUrl = `${BackendApiBaseUrl}/empprofile/ratings/get`;
const messagesCountUrl = `${BackendApiBaseUrl}/empprofile/messages/counts`;

/******************************************Messages**************************************/

const getFiltersUrl = `${BackendApiBaseUrl}/guest/getfilters`;
const getMyGigFiltersUrl = `${BackendApiBaseUrl}/guest/allmygigscounts`;
const getCompanyProfileDetailsUrl = `${BackendApiBaseUrl}/empprofile/getcompanyprofile`;
// const getCompanyProfileDetailsUrl =  `http://localhost:3000/staging/empprofile/getcompanyprofile`;

const getCompanyGigsUrl = `${BackendApiBaseUrl}/empprofile/getjobcounts`;

const getPersonalDetailsLocationUrl = `${BackendApiBaseUrl}/skill/locations`;
// const getPersonalDetailsLocationUrl = `${BackendApiBaseUrl}/skill/locations`;
const getExtTalLocationsUrl = `${BackendApiBaseUrl}/skill/ext-tal-locations`;
const sendAttachments = `${BackendApiBaseUrl}/message/attachment`;
const createInterviewUrl = `${BackendApiBaseUrl}/interview/create`;
let updateInterviewUrl = `${BackendApiBaseUrl}/interview/empupdate`;

//Interviews

// const getAllInterviewsUrl = `${BackendApiBaseUrl}/interview/getallinterviews`;
const getAllInterviewsUrl = `${BackendApiBaseUrl}/interview/getallinterviews`;

//CAndidate Profile
const profileDetailsUrl = `${BackendApiBaseUrl}/guest/get`;
const profileDetailReviews = `${BackendApiBaseUrl}/guest/getreviews`;
const postNotesApiUrl = `${BackendApiBaseUrl}/skill/note`;
const getNotesApiUrl = `${BackendApiBaseUrl}/skill/note`;
const updateNotesApiUrl = `${BackendApiBaseUrl}/skill/note`;
const getRemindersUrl = `${BackendApiBaseUrl}/skill/DashboardNotes`;
const getCoversationIdURL = `${BackendApiBaseUrl}/guest/getbidconversation`;

//Personal Details
const updatePersonalDetailsUrl = `${BackendApiBaseUrl}/empprofile/onboarding/update`;

//Search
const getSearchSuggestionUrl = `${BackendApiBaseUrl}/search`;

//Company Profile
const getCompanyDetailsDropdownUrl = `${BackendApiBaseUrl}/empprofile/companydetails`;
const postCompanyDetailsUrl = `${BackendApiBaseUrl}/empprofile/onboarding/update`;
const updateCompanyDetailsUrl = `${BackendApiBaseUrl}/empprofile/updatedetails`;
const verifyEmailUrl = `${BackendApiBaseUrl}/verifyEmail`;

const fetchAllGigsUrl = `${BackendApiBaseUrl}/bids/searchGigs`;
const AddMessageToFavouriteUrl = `${BackendApiBaseUrl}/empprofile/favorites/add`;
const fetchFollowersUrl = `${BackendApiBaseUrl}/empprofile/getfollowers`;
const updateEmpProfileAlbumsUrl = `${BackendApiBaseUrl}/empprofile/albums/update`;
const eidtEmpProfileAlbumsUrl = `${BackendApiBaseUrl}/empprofile/albums/updatepic`;

const deleteEmpProfileAlbumsUrl = `${BackendApiBaseUrl}/empprofile/albums/delete`;
const getEmpProfileAlbumsUrl = `${BackendApiBaseUrl}/empprofile/albums/get`;
const createGigUrl = `${BackendApiBaseUrl}/empgigs`;
const getSearchSkillsUrl = `${BackendApiBaseUrl}/skill/getSkills`;
const updateGigUrl = `${BackendApiBaseUrl}/empgigs/update`;
const searchDepartmentsUrl = `${BackendApiBaseUrl}/departments`;
const searchTalentsUrl = `${BackendApiBaseUrl}/projects/engro-talents`;
const createProjectUrl = `${BackendApiBaseUrl}/projects`;
const fetchProjectsUrl = `${BackendApiBaseUrl}/projects`;

//SKillListings
const userSkillListing = `${BackendApiBaseUrl}/skill/listing`;
const SkillListingTotalCount = `${BackendApiBaseUrl}/guest/filterscount`;
const SkillListingCount = `${BackendApiBaseUrl}/guest/allcounts`;
//Jobs/Gigs
const getJobListingUrl = `${BackendApiBaseUrl}/empgigs/getmygigs`;
const getJobCountsUrl = `${BackendApiBaseUrl}/empgigs/getmygigcounts/$`;
const getCandidateCountsUrl = `${BackendApiBaseUrl}/guest/totalcountsprivate`;
const getRecentJobListingUrl = `${BackendApiBaseUrl}/empgigs/getrecent`;

const getJobListingDraftUrl = `${BackendApiBaseUrl}/empgigs/getmygigsdraft`;
const checkUserName = `${BackendApiBaseUrl}/auth/check-username`;
const getHRMSUrl = `${BackendApiBaseUrl}/empprofile/getHRMs`;

const getMyMatchesUrl = `${BackendApiBaseUrl}/empgigs/getmygigmatches`;
const perUserSkillListing = `${BackendApiBaseUrl}/empprofile/getskilllisting`;
const guestUserSkillListing = `${BackendApiBaseUrl}/guest/getskilllisting`;
const downloadSelectedDocumentsUrl = `${BackendApiBaseUrl}/empprofile/documents/download-selected`;
const deleteJobUrl = `${BackendApiBaseUrl}/empgigs/delete`;
const getJobDetailUrl = `${BackendApiBaseUrl}/empgigs`;
const getJobBidDetailUrl = `${BackendApiBaseUrl}/empgigs/GetGigDetail`;

// recent search url
const recentSearchUrl = `${BackendApiBaseUrl}/guest/getRecents`;
const trendingJobsUrl = `${BackendApiBaseUrl}/bids/trendings`;
const clearRecentSearchUrl = `${BackendApiBaseUrl}/guest/clearRecents`;

//Post A Job
const fetchjobTemplateUrl = `${BackendApiBaseUrl}/empgigs/templates`;

const JobTitleUrl = `${BackendApiBaseUrl}/empgigs/get/gigtitle`;
const searchProfessionsUrl = `${BackendApiBaseUrl}/professions/search`;
const nlSearchWriteWithAiUrl = `${BackendApiBaseUrl}/empprofile/nl-search/write-with-ai`;
const addUpdateUserDeviceDeatilsURL = `${BackendApiBaseUrl}/profile/user-device`;
//employerdashboard
const fetchdashboardUrl = `${BackendApiBaseUrl}/empprofile/dashboard`;
// const fetchdashboardInterviewUrl = `http://localhost:3000/production/empprofile/dashboardInterviews`;
const fetchdashboardInterviewUrl = `${BackendApiBaseUrl}/empprofile/dashboardInterviews`;
// const fetchdashboardMatchesUrl = `http://localhost:3000/production/empprofile/dashboardMatches`;
const fetchdashboardMatchesUrl = `${BackendApiBaseUrl}/empprofile/dashboardMatches`;
//Favorites
// const fetchFavoritesUrl = `${BackendApiBaseUrl}/empprofile/favorites/get?type=web&page=1&perPage=`;
const fetchFavoritesUrl = `${BackendApiBaseUrl}/empprofile/favorites/get`;
//Post a Favorite
const postFavoriteUrl = `${BackendApiBaseUrl}/empprofile/favorites/add `;
//Delete a Favorite
const deleteFavoriteUrl = `${BackendApiBaseUrl}/empprofile/favorites/remove`;

const getCulturePhotosUrl = `${BackendApiBaseUrl}/empprofile/albums/get`;
const removeMessageFromFavouriteUrl = `${BackendApiBaseUrl}/empprofile/favorites/remove`;
const fetchViewsUrl = `${BackendApiBaseUrl}/empprofile/getviews`;
//Skill Matches
const getMatchedSkillsUrl = `${BackendApiBaseUrl}/empgigs/match/get`;
const addToMatchUrl = `${BackendApiBaseUrl}/empgigs/match/add`;
const batchMatchUrl = `${BackendApiBaseUrl}/empgigs/multi-matches/add`;
const removeFromMatchUrl = `${BackendApiBaseUrl}/empgigs/match/delete`;
const findMyMatches = `${BackendApiBaseUrl}/empgigs/matchesRecommendations/get`;
const matchesCount = `${BackendApiBaseUrl}/empgigs/GetGigMatchesCounts`;
const matchesPagination = `${BackendApiBaseUrl}/empgigs/matches/pagination`;

//Timesheet
// const getTimeSheetListUrl = `${BackendApiBaseUrl}/getall`;
const getTimeSheetListUrl = `${BackendApiBaseUrl}/timesheet-details`;
const getTimesheetUrl = `${BackendApiBaseUrl}/getTimesheet`;
const approveTimesheetUrl = `${BackendApiBaseUrl}/timesheet/edit`;
const editTimesheetUrl = `${BackendApiBaseUrl}/timesheet/edit`;
const approveAllTimesheetUrl = `${BackendApiBaseUrl}/timesheets-approved`;
const approveTimeOffUrl = `${BackendApiBaseUrl}/timeoff/edit`;
const getGraphDetailsUrl = `${BackendApiBaseUrl}/getgraph`;
const rejectTimesheetUrl = `${BackendApiBaseUrl}/timesheet/corrections`;

//3d Resume
const getResume3dUrl = `${BackendApiBaseUrl}/emp3dresume/get`;
// const viewIncrementUrl = `${BackendApiBaseUrl}/emp3dresume/getviews`;
// const viewFollowersUrl = `${BackendApiBaseUrl}/emp3dresume/getfollowers`;
const viewFollowersUrl = `${BackendApiBaseUrl}/emp3dresume/getfollowers`;
const viewIncrementUrl = `${BackendApiBaseUrl}/emp3dresume/getviews`;

const followUrl = `${BackendApiBaseUrl}/empprofile/follow/add`;
const unFollowUrl = `${BackendApiBaseUrl}/empprofile/follow/remove`;

//Notifications
// const notificationUrl = `${BackendApiBaseUrl}/empprofile/notifications/get`;
const notificationUrl = `${BackendApiBaseUrl}/empprofile/notifications/get`;
// const notificationUrl = `http://192.168.18.101:4000/production/empprofile/notifications/get`;
const readNotificationUrl = `${BackendApiBaseUrl}/empprofile/notification/update`;

//My team
const getAllTeamMembersUrl = `${BackendApiBaseUrl}/empprofile/teammembers/all`;
const addTeamMembersUrl = `${BackendApiBaseUrl}/empprofile/teammembers/add`;
const updateTeamMembersUrl = `${BackendApiBaseUrl}/empprofile/teammembers/update`;
const changeTeamMemberPasswordUrl = `${BackendApiBaseUrl}/empprofile/teammembers/change-password`;
const deleteTeamMemberUrl = `${BackendApiBaseUrl}/empprofile/teammembers/delete`;
const getAllPaymentsUrl = `${BackendApiBaseUrl}/empprofile/payments/getAll`;
const reactivateTeamMemberUrl = `${BackendApiBaseUrl}/empprofile/teammembers/reactivate`;
const activateTeamMemberUrl = `${BackendApiBaseUrl}/empprofile/teammembers/update`;
// Manage Candidates --> get candidates/egetcandidates/get

const getCandidatesUrl = `${BackendApiBaseUrl}/empprofile/getcandidates/get`;
const candidatesUrl = `${BackendApiBaseUrl}/empprofile/getcandidates`;
// const getCandidateCountUrl = `${BackendApiBaseUrl}/empprofile/getCandidatesCounts`;
const getCandidateCountUrl = `${BackendApiBaseUrl}/empprofile/getCandidatesCountsNew`;
//My Matches
const getMatchesUrl = `${BackendApiBaseUrl}/empgigs/getmygigmatches`;
const getABSurl = `${BackendApiBaseUrl}/empprofile/ABS/get`;
const getFollowersApi = `${BackendApiBaseUrl}/emp3dresume/getfollowers`;
const removePrivateTalent = `${BackendApiBaseUrl}/empprofile/removePrivateTalent`;
// const getFollowersApi= `${BackendApiBaseUrl}/emp3dresume/getfollowers`
const HubspotAPI = `${BackendHubspotAPI}/subscribe/dispatch`;

const getHRMDetailsAPI = `${BackendApiBaseUrl}/empprofile/getHRMsDetails`;
const getABSDetailsAPI = `${BackendApiBaseUrl}/empprofile/ABSFacilities`;

const UserTrackingURL = `${BackendApiBaseUrl}/user-tracking`;
const checkEmailExistURL = `${BackendApiBaseUrl}/profile/emailExist`;
const profileAddCandidateURL = `${BackendApiBaseUrl}/profile/addCandidate`;

const invitedTalentURL = `${BackendApiBaseUrl}/empprofile/invitedCandidates`;
const inviteTrackingInvitesURL = `${BackendApiBaseUrl}/invite-tracking`;
const searchInvitedTalentURL = `${BackendApiBaseUrl}/api/invitedCandidates`;
const numberCheckURL = `${BackendApiBaseUrl}/check-number`;
const timeSheet = `${BackendApiBaseUrl}/timesheet`;
const updateConfigTimeSheet = `${BackendApiBaseUrl}/updateConfigureTimesheet`;
const timeOffURL = `${BackendApiBaseUrl}/get-timeoff-date-range`;
const downloadTimeSheetURL = `${BackendApiBaseUrl}/export-timesheet`;
const configedTimesheet = `${BackendApiBaseUrl}/get-configure-timesheet`;
const VmsFilterUrl = `${BackendApiBaseUrl}/guest/gigs/vms`;
const FacilityNameUrl = `${BackendApiBaseUrl}/guest/gigs/facilities`;

const dashboardTagUrl = `${BackendApiBaseUrl}/empprofile/get-usertag`;
const planPurchaseUrl = `${BackendApiBaseUrl}/credits/plans/purchase`;
const plansUrl = `${BackendApiBaseUrl}/credits/plans`;
const creditsBalanceUrl = `${BackendApiBaseUrl}/credits/balance`;
const creditsBannerUrl = `${BackendApiBaseUrl}/credits/banner`;
const creditsTransactionsUrl = `${BackendApiBaseUrl}/credits/transactions`;
const creditsPortalSessionUrl =   `${BackendApiBaseUrl}/credits/portal/session`;
const creditsInvoicesUrl = `${BackendApiBaseUrl}/credits/invoices`;

const writeWithAiUrl = `${BackendApiBaseUrl}/empprofile/onboarding/first-job`;
const writeWithAiDescriptionUrl = `${BackendApiBaseUrl}/empprofile/onboarding/write-with-ai`;
const brandfetchSearchUrl = `${BackendApiBaseUrl}/empprofile/company/brandfetch/search`;

// QueryPage APIs
const searchExternalUsersUrl = `${BackendApiBaseUrl}/profile/external_users/search`;
const nlSearchExternalUrl = `${BackendApiBaseUrl}/profile/external_users/nl_search`;
const getAssociatedTalentsUrl = `${BackendApiBaseUrl}/guest/associated-talents`;
const pmtTalentsSearchUrl = `${BackendApiBaseUrl}/guest/pmt-talents-search`;
const searchSkillListingQueryUrl = `${BackendApiBaseUrl}/guest/skilllisting/search`;
const aiSearchUrl = `${BackendApiBaseUrl}/nl-search`;
const inviteExternalUserUrl = `${BackendApiBaseUrl}/profile/external_users`;
const fetchExternalContactUrl = `${BackendApiBaseUrl}/profile/external_users/details`;
const currenciesUrl = `${BackendApiBaseUrl}/guest/currencies`;

let token = null;
let headers = null;
let ImpersonationId = null;
let currentLocationPayload = null;

const getBrowserCoordinates = () =>
  new Promise((resolve) => {
    if (typeof navigator === "undefined" || !navigator.geolocation) {
      resolve(null);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          accuracy: position.coords.accuracy,
        });
      },
      () => resolve(null),
      {
        enableHighAccuracy: true,
        timeout: 15000,
        maximumAge: 0,
      }
    );
  });

const getIpLocation = async (ipAddress) => {
  try {
    const response = await axios.get(
      ipAddress ? `https://ipapi.co/${ipAddress}/json/` : "https://ipapi.co/json/"
    );
    const data = response?.data || {};

    if (!data.latitude && !data.longitude && !data.city && !data.country_name) {
      return null;
    }

    return {
      ...(data.latitude !== undefined && { latitude: data.latitude }),
      ...(data.longitude !== undefined && { longitude: data.longitude }),
      city: data.city || "",
      region: data.region || "",
      country: data.country_name || data.country || "",
      postalCode: data.postal || "",
      timezone: data.timezone || "",
      source: "ip",
    };
  } catch (error) {
    return null;
  }
};

const getCurrentUserLocationPayload = async () => {
  if (
    currentLocationPayload?.CurrentLocation &&
    Object.keys(currentLocationPayload.CurrentLocation).length
  ) {
    return currentLocationPayload;
  }

  try {
    const [ipResult, coordinatesResult] = await Promise.allSettled([
      axios.get("https://api.ipify.org?format=json"),
      getBrowserCoordinates(),
    ]);
    const ipAddress =
      ipResult.status === "fulfilled" ? ipResult.value?.data?.ip || "" : "";
    const browserCoordinates =
      coordinatesResult.status === "fulfilled" ? coordinatesResult.value : null;
    const location = browserCoordinates
      ? { ...browserCoordinates, source: "browser" }
      : await getIpLocation(ipAddress);

    const payload = {
      ipAddress,
      CurrentLocation: location || {},
    };

    if (location) {
      currentLocationPayload = payload;
    }

    return payload;
  } catch (error) {
    return {
      ipAddress: "",
      CurrentLocation: {},
    };
  }
};

const fetchHeader = (token, ImpersonationId) => {
  let email = localStorage.getItem("email");
  if (ImpersonationId) {
    headers = {
      "Content-Type": "application/json",
      Authorization: token,
      impersonationid: ImpersonationId,
      "Access-Control-Allow-Origin": "*",
      // params: "61264b4304ff062ef86cec27",
    };
  } else {
    headers = {
      "Content-Type": "application/json",
      Authorization: token,
      "Access-Control-Allow-Origin": "*",
      // email: email,
    };
  }

  return headers;
};

export const checkUserNameUnique = async (payload) => {
  const response = await axios.post(`${checkUserName}`, payload);

  return response;
};

export const fetchToken = async () => {
  token = await (store.getState().authReducer.user
    ? store.getState().authReducer.user.authToken
    : null);
  ImpersonationId = await store.getState().authReducer.impersonationId;

  return fetchHeader(token, ImpersonationId);
};

// fetch Profile Experience
export const fetchProfileExperienceAPI = async () => {
  const response = await axios.get(fetchProfileExperience);
  return response;
};

export const getFollowersV2 = async (payload) => {
  const headers = await fetchToken();
  const response = await axios.put(`${getFollowersApi}/${payload.id}`, "", {
    headers,
  });
  return response;
};

//city
// export const searchLocationSuggestionsApi = async (value) => {
//   let locFilterType;
//   if(value.payload.obj.type == 'city'){
//    locFilterType='city'
//   }
//   else if(value.payload.obj.type == 'region'){
//    locFilterType='region'
//   }
//   else if(value.payload.obj.type == 'state'){
//    locFilterType='state'
//   }
//   const fetchLocationAPI = `http://192.168.18.49:4000/development/skill/locationsuggestion?${locFilterType}=${value.payload.obj.value}`;
//    const response = await axios.get(fetchLocationAPI);
//   return response;
// };

// get regions

export const searchRegionSuggestionsApi = async (value) => {
  var fetchLocationAPI;
  if (value.payload == undefined) {
    fetchLocationAPI = `${BackendApiBaseUrl}/skill/getregions`;
  } else {
    fetchLocationAPI = `${BackendApiBaseUrl}/skill/getregions?region=${value.payload.obj.value}`;
  }

  const response = await axios.get(fetchLocationAPI);
  return response;
};
//Dynamic Locations
export const searchLocationSuggestionsApi = async (value) => {
  var fetchLocationAPI;
  const headers = await fetchToken();
  if (value.payload.value == undefined) {
    fetchLocationAPI = `${BackendApiBaseUrl}/guest/getSkillListingLocation`;
  } else {
    fetchLocationAPI = `${BackendApiBaseUrl}/guest/getSkillListingLocation?${value.payload.value}`;
  }
  const response = await axios.put(fetchLocationAPI, value.payload.body, {
    headers,
  });
  return response;
};

export const searchCompaniesAndIndustriesApi = async (value) => {
  var fetchCompanyAndIndustryAPI;
  const headers = await fetchToken();
  if (value.payload.value == undefined) {
    fetchCompanyAndIndustryAPI = `${BackendApiBaseUrl}/guest/getSkillListingIndustryCompany`;
  } else {
    fetchCompanyAndIndustryAPI = `${BackendApiBaseUrl}/guest/getSkillListingIndustryCompany?${value.payload.value}`;
  }
  const response = await axios.put(
    fetchCompanyAndIndustryAPI,
    value.payload.body,
    {
      headers,
    },
  );
  return response;
};

export const searchSkillsApi = async (value) => {
  var fetchSkillsAPI;
  const headers = await fetchToken();
  if (value.payload.value == undefined) {
    fetchSkillsAPI = `${BackendApiBaseUrl}/guest/getSkillListingSkills`;
  } else {
    fetchSkillsAPI = `${BackendApiBaseUrl}/guest/getSkillListingSkills?${value.payload.value}`;
  }
  const response = await axios.put(fetchSkillsAPI, value.payload.body, {
    headers,
  });
  return response;
};

// get countries

export const searchStateSuggestionsApi = async (value) => {
  var fetchLocationAPI;
  if (value.payload == undefined) {
    fetchLocationAPI = `${BackendApiBaseUrl}/skill/getcountries`;
  } else {
    fetchLocationAPI = `${BackendApiBaseUrl}/skill/getcountries?country=${value.payload.obj.value}`;
  }
  const response = await axios.get(fetchLocationAPI);
  return response;
};
// Fetch Location API
export const fetchSearchLocationAPI = async (value) => {
  const fetchLocationAPI = `${BackendApiBaseUrl}/skill/locations?location=${value.payload}`;
  const response = await axios.get(fetchLocationAPI);
  return response;
};

// Fetch User Skill Listings
export const fetchUserSkillListingAPI = async () => {
  const headers = await fetchToken();
  const response = await axios.get(skillListingUrl, { headers });
  return response;
};

export const fetchDeclinedReasonsBidsAPI = async (payload) => {
  const headers = await fetchToken();
  const response = await axios.get(
    `${fetchDeclineReasonsURL}/${payload}`,
    // `${fetchReceivedBidsDetailUrl}/declinedstatus/${payload}`,
    {
      headers,
    },
  );
  return response;
};

export const postRatingAPI = async (params) => {
  const headers = await fetchToken();
  const response = await axios.post(postRatingUrl, params, { headers });
  return response;
};

export const putRatingAPI = async (params) => {
  const headers = await fetchToken();
  const response = await axios.put(
    `${putRatingUrl}/${params.Ratings_id}`,
    params,
    { headers },
  );
  return response;
};

export const deleteRatingAPI = async (params) => {
  const headers = await fetchToken();
  const response = await axios.put(
    `${deleteRatingsUrl}/${params.Ratings_id}`,
    params,
    { headers },
  );
  return response;
};

// Fetch Discipline API
export const fetchSearchDisciplineAPI = async (value) => {
  const fetchDisciplineAPI = `${BackendApiBaseUrl}/skill/discipline?discipline=${value.payload}`;
  const response = await axios.get(fetchDisciplineAPI);
  return response;
};

export const fetchSearchSkillAPI = async (value) => {
  const categoryId = isHC(value.payload.profCode) ? 3 : 1;
  const fetchDisciplineAPI = `${BackendApiBaseUrl}/skill/discipline?discipline=${value.payload.val}&categoryId=${categoryId}`;
  const response = await axios.get(fetchDisciplineAPI);
  return response;
};

// LinkedIN User
const fetchLinkedInToken = `${BackendApiBaseUrl}/auth/linkedInSignin`;
export const approveLinkedInUserAPI = async (token) => {
  const response = await axios.post(
    fetchLinkedInToken,
    {
      code: token,
      redirectURL: `${process.env.REACT_APP_MY_URL}/linkcheck`,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
  return response;
};

export const fetchDocsList = async () => {
  const headers = await fetchToken();
  const response = await axios.get(fetchDocUrl, { headers });
  return response;
};

export const getHRMSApi = async () => {
  const headers = await fetchToken();
  const response = await axios.get(getHRMSUrl, { headers });
  return response;
};

export const uploadFileApi = async (request, userToken) => {
  const headers = await fetchToken();
  const { file } = request.params;
  const contentType = file.type;
  request.params["contentType"] = contentType;
  const response = await axios.post(uploadFileUrl, request.params, {
    headers,
  });
  const { uploadURL, Key } = response.data;
  const uploadResponse = await axios.put(uploadURL, file);
  if (uploadResponse.status == 200) {
    return { data: { status: "success", payload: Key } };
  } else {
    return {
      data: {
        status: "error",
        error: { message: "File upload failed", code: uploadResponse.status },
      },
    };
  }
};

export const uploadDocApi = async (request) => {
  const response = await axios.post(uploadDocUrl, request.params, {
    headers: { "Content-Type": "multipart/form-data", Authorization: token },
  });
  return response;
};

export const removeDocApi = async (request) => {
  await fetchToken();
  const response = await axios.delete(`${fetchDocUrl}/${request.params}`, {
    headers: { Authorization: token },
  });
  return response;
};

export const fetchProfileURL = async (params) => {
  if (params?.impersonationId) {
    headers = fetchHeader(params.token, params.impersonationId);
  } else {
    headers = await fetchToken();
  }
  const response = await axios.get(fetchProfileDetails, {
    // headers: { Authorization: token },
    headers,
  });
  return response;
};

export const updateProfileApi = async (request) => {
  const headers = await fetchToken();
  const response = await axios.put(`${updateProfileUrl}`, request.params, {
    headers,
  });
  return response;
};

export const uploadProfilePicApi = async ({ params }) => {
  await fetchToken();
  const response = await axios.put(`${uploadDPUrl}`, params, {
    headers: { "Content-Type": "multipart/form-data", Authorization: token },
  });
  return response;
};

export const fetchSkillsApi = async (request) => {
  const categoryId = 3;

  const response = await axios.get(
    `${getSkillsUrl}?skillName=${request.params}&SkillCategoryId=${categoryId}`,
  );
  return response;
};

export const getSkillSuggestionsApi = async (keyword) => {
  const response = await axios.get(
    `${getSkillsUrl}?skillName=${encodeURIComponent(keyword)}&SkillCategoryId=1`,
  );
  return response;
};

export const createSkillListingApi = async (request) => {
  const headers = await fetchToken();
  const response = await axios.post(`${skillListingUrl}`, request.params, {
    headers,
  });
  return response;
};

export const updateSkillListingApi = async (request) => {
  const headers = await fetchToken();
  const response = await axios.put(
    `${skillListingUrl}/${request.params.id}`,
    request.params,
    {
      headers,
    },
  );
  return response;
};

export const fetchDataApi = async (params) => {
  return await axios.get(fetchDataUrl);
};

export const sendDataApi = async (params) => {
  const data = JSON.stringify(params);
  return await axios.post(sendDataUrl, data, { headers });
};

export const checkUserApi = async (request) => {
  const response = await axios.post(
    fetchExistUserUrl,
    { email: request.params },
    { headers },
  );
  return response;
};

export const passwordlessStartApi = async ({
  email,
  purpose = "login",
  accountType = "EMP",
  fullName = "",
  source = "skillradar",
}) => {
  const payload =
    purpose === "signup"
      ? { email, accountType, fullName, source }
      : { email };

  return await axios.post(
    passwordlessStartUrl,
    payload,
    { headers },
  );
};

export const passwordlessConfirmApi = async ({ email, code, session }) => {
  return await axios.post(
    passwordlessConfirmUrl,
    { email, code, session },
    { headers },
  );
};

export const viewIncrementApi = async (request) => {
  const headers = await fetchToken();
  const response = await axios.put(
    `${viewIncrementUrl}/${request.payload}`,
    request.payload,
    { headers },
  );
  return response;
};

export const fetchChatHistoryApi = async (id) => {
  const headers = await fetchToken();
  return await axios.get(`${getChatHistoryUrl}/${id}`, { headers });
  // const response = fetch(`${getChatHistoryUrl}/${id}`, { mode: 'cors', cache: 'no-cache', headers: { 'Access-Control-Allow-Origin': '*', "Content-Type": "application/json", 'Authorization': token } })
  // return response
};

export const fetchConversationCountAPI = async (request) => {
  const headers = await fetchToken();
  if (
    request?.HRMid == null &&
    request?.bidType == null &&
    request?.bidStatus == null
  ) {
    return await axios.get(`${fetchConversationCountUrl}`, { headers });
  } else {
    // t t t
    if (
      request?.bidType !== null &&
      request?.bidStatus != "null" &&
      request.bidStatus != null &&
      request?.HRMid != null
    ) {
      return await axios.get(
        `${fetchConversationCountUrl}?bidStatus=${request?.bidStatus}&bidType=${request.bidType}&HRMid=${request.HRMid}`,
        { headers },
      );
    }
    // t f f
    if (
      request?.bidType !== null &&
      (request?.bidStatus == "null" || request.bidStatus == null) &&
      request?.HRMid == null
    ) {
      return await axios.get(
        `${fetchConversationCountUrl}?bidType=${request.bidType}`,
        { headers },
      );
    }

    // f t t
    if (
      request?.bidType == null &&
      request?.bidStatus != "null" &&
      request.bidStatus != null &&
      request?.HRMid != null
    ) {
      return await axios.get(
        `${fetchConversationCountUrl}?bidStatus=${request?.bidStatus}&HRMid=${request.HRMid}`,
        { headers },
      );
    }

    // f f t
    if (
      request?.bidType == null &&
      (request.bidStatus == null || request.bidStatus == "null") &&
      request.HRMid != null
    ) {
      return await axios.get(
        `${fetchConversationCountUrl}?HRMid=${request.HRMid}`,
        { headers },
      );
    }

    // t f t
    if (
      request.bidType != null &&
      (request?.bidStatus == "null" || request?.bidStatus == null) &&
      request?.HRMid != null
    ) {
      return await axios.get(
        `${fetchConversationCountUrl}?bidType=${request?.bidType}&HRMid=${request.HRMid}`,
        { headers },
      );
    }
    // f t f
    if (
      request.bidType == null &&
      request?.bidStatus != "null" &&
      request?.bidStatus != null &&
      request?.HRMid == null
    ) {
      return await axios.get(
        `${fetchConversationCountUrl}?bidStatus=${request?.bidStatus}`,
        { headers },
      );
    }
    // f f f
    if (
      request.bidType == null &&
      (request?.bidStatus == "null" || request?.bidStatus == null) &&
      request?.HRMid == null
    ) {
      return await axios.get(`${fetchConversationCountUrl}`, { headers });
    }
  }
};

export const fetchMessagesAPI = async (messageType, limit, skip) => {
  const headers = await fetchToken();
  return await axios.get(
    `${fetchMessagesUrl}/${messageType}/${limit}/${skip}`,
    { headers },
  );
};

export const getInboxMessagesAPi = async (payload) => {
  const headers = await fetchToken();
  const searchParam = payload?.search
    ? `&search=${encodeURIComponent(payload.search)}`
    : "";
  const vmsParam = payload?.vmsValue
    ? `&VMS=${encodeURIComponent(payload.vmsValue)}`
    : "";
  if (payload?.hrmId && payload?.hrmId != 0)
    return await axios.get(
      `${getInboxUrl}/${payload.conversationType}/${payload.bidType}/${
        payload.bidStatus
      }?type=${"emp"}&page=${payload.page ?? 1}&perPage=${
        payload.perPage ?? 5
      }&HRMid=${payload?.hrmId}${searchParam}${vmsParam}`,
      { headers },
    );
  if (payload?.jobOrderId && payload?.hrmId && payload?.hrmId != 0)
    return await axios.get(
      `${getInboxUrl}/${payload.conversationType}/${payload.bidType}/${
        payload.bidStatus
      }?type=${"emp"}&page=${payload.page ?? 1}&perPage=${
        payload.perPage ?? 5
      }&HRMid=${payload?.hrmId}&jobId=${payload?.jobOrderId}&jobType=${
        payload?.jobType
      }${searchParam}${vmsParam}`,
      { headers },
    );
  if (payload?.jobOrderId)
    return await axios.get(
      `${getInboxUrl}/${payload.conversationType}/${payload.bidType}/${
        payload.bidStatus
      }?type=emp&page=${payload.page ?? 1}&perPage=${
        payload.perPage ?? 5
      }&jobId=${payload?.jobOrderId}&jobType=${payload?.jobType}${searchParam}${vmsParam}`,
      { headers },
    );

  return await axios.get(
    `${getInboxUrl}/${payload.conversationType}/${payload.bidType}/${
      payload.bidStatus
    }?type=emp&page=${payload.page ?? 1}&perPage=${
      payload.perPage ?? 5
    }${searchParam}${vmsParam}`,
    { headers },
  );
};

// export const getInboxMessagesAPi = async (payload) => {

//   const headers = await fetchToken();
//   // favourites
//   if (payload?.hrmId && payload?.hrmId != 0)
//     return await axios.get(
//       `${getInboxUrl}/${payload.conversationType}/${payload.bidType}/${
//         payload.bidStatus
//       }?type=${"emp"}&page=${payload.page ?? 1}&perPage=${
//         payload.perPage ?? 5
//       }&HRMid=${payload?.hrmId}${
//         payload?.value ? `&search=${payload?.value}` : ""
//       }`,
//       { headers }
//     );
//   if (payload?.jobOrderId && payload?.hrmId && payload?.hrmId != 0)
//     return await axios.get(
//       `${getInboxUrl}/${payload.conversationType}/${payload.bidType}/${
//         payload.bidStatus
//       }?type=${"emp"}&page=${payload.page ?? 1}&perPage=${
//         payload.perPage ?? 5
//       }&HRMid=${payload?.hrmId}&jobId=${payload?.jobOrderId}&jobType=${
//         payload?.jobType
//       }${payload?.value ? `&search=${payload?.value}` : ""}`,
//       { headers }
//     );
//   if (payload?.jobOrderId)
//     return await axios.get(
//       `${getInboxUrl}/${payload.conversationType}/${payload.bidType}/${
//         payload.bidStatus
//       }?type=${"emp"}&page=${payload.page ?? 1}&perPage=${
//         payload.perPage ?? 5
//       }&jobId=${payload?.jobOrderId}&jobType=${payload?.jobType}${
//         payload?.value ? `&search=${payload?.value}` : ""
//       }`,
//       { headers }
//     );
//   return await axios.get(
//     `${getInboxUrl}/${payload.conversationType}/${payload.bidType}/${
//       payload.bidStatus
//     }?type=${"emp"}&page=${payload.page ?? 1}&perPage=${payload.perPage ?? 5}${
//       payload?.value ? `&search=${payload?.value}` : ""
//     }`,
//     { headers }
//   );
// };

export const MessageAttachmentAPi = async (payload) => {
  const headers = await fetchToken();
  return await axios.post(`${sendAttachments}`, payload, { headers });
};

export const sendMessageAPI = async (
  conversationId,
  recipientId,
  message,
  formData,
) => {
  const headers = await fetchToken();
  if (formData) {
    // const fileUploadResponse = await axios.request({
    //   url: sendAttachments,
    //   method: "post",
    //   processData: false,
    //   data: formData,
    // });
    const data = {
      ConversationId: conversationId,
      RecipientUserId: recipientId,
      MessageText: message,
      Attachments: formData,
    };
    return await axios.post(`${sendMessageUrl}`, data, { headers });
  } else {
    const data = {
      ConversationId: conversationId,
      RecipientUserId: recipientId,
      MessageText: message,
    };
    return await axios.post(`${sendMessageUrl}`, data, { headers });
  }
};

export const makeOfferAPi = async (params) => {
  const headers = await fetchToken();
  return await axios.post(
    `${offerAttachment}/${params.id.id}`,
    params?.data?.value ?? params?.data,
    {
      headers,
    },
  );
};

export const editOfferApi = async (params) => {
  const headers = await fetchToken();
  const results = await axios.put(
    `${editOfferUrl}/${params.id.id}`,
    params?.data?.value ?? params?.data,
    {
      headers,
    },
  );
  const HubSpotTrigger = {
    EventType: "Event_Bid_OnHired",
    GigID: results?.data?.GigId,
    ProfileID: results?.data?.ProfileId,
    SkillListingID: results?.data?.SkillListing?.SkillListingId,
    EmployerID: results?.data?.Gig?.ProfileId,
    Status: "Hired",
  };
  const HubSpotResults = axios.post(
    `${HubspotAPI}?id=${results?.data?.BidId}`,
    HubSpotTrigger,
    { headers },
  );
  return results;
};

export const createBidApi = async (request) => {
  const data = JSON.stringify(request.payload);
  const headers = await fetchToken();
  return await axios.post(createBidUrl, data, { headers });
};

export const createmultiBidApi = async (request) => {
  const data = JSON.stringify(request.payload);
  const headers = await fetchToken();
  return await axios.post(createmultiBidUrl, data, { headers });
};

export const updateBidApi = async (request) => {
  const data = JSON.stringify(request.payload);
  const headers = await fetchToken();
  return await axios.put(`${updateBidUrl}/${request.payload.id}`, data, {
    headers,
  });
};

export const retractBidApi = async (request) => {
  const headers = await fetchToken();
  return await axios.put(
    `${updateBidUrl}/${request.params.id}`,
    request.params,
    {
      headers,
    },
  );
};

//Interview
//Create interview API
export const createInterviewApi = async (request) => {
  const data = request.payload;
  const headers = await fetchToken();
  return await axios.post(
    `${createInterviewUrl}/${request.payload.bid_id}`,
    data,
    { headers },
  );
};

//Update interview API
export const updateInterviewApi = async (request) => {
  updateInterviewUrl = "";
  // const {InterviewStatus, DeclineReasonId, GigId,  Reason, ApprovedScheduledTiming, ScheduledTimings} = request.payload;
  const data = JSON.stringify(request.payload);
  if (
    request?.payload?.InterviewStatus == "Rescheduled" ||
    request.payload.reschedule
  ) {
    updateInterviewUrl = `${BackendApiBaseUrl}/interview/update`;
  } else if (request?.payload?.talent == true) {
    updateInterviewUrl = `${BackendApiBaseUrl}/interview/update`;
  } else {
    updateInterviewUrl = `${BackendApiBaseUrl}/interview/empupdate`;
  }
  const headers = await fetchToken();
  return await axios.put(
    `${updateInterviewUrl}/${request.payload.InterviewId}`,
    data,
    { headers },
  );
};
export const getProfileDetailAPi = async (id) => {
  // const headers=await fetchToken();
  const response = await axios.get(`${profileDetailsUrl}/${id}`, { headers });
  return response;
};

export const getProfileReviewsAPi = async (id) => {
  // const headers=await fetchToken();
  const response = await axios.get(`${profileDetailReviews}/${id}`, {
    headers,
  });
  return response;
};

// Update Profile Details
export const updatePersonalDetailsApi = async (params) => {
  const data = JSON.stringify(params);
  const headers = await fetchToken();
  return await axios.put(updatePersonalDetailsUrl, data, { headers });
};

export const getCompanyProfileDetailsApi = async () => {
  const headers = await fetchToken();
  const response = await axios.get(`${getCompanyProfileDetailsUrl}`, {
    headers,
  });
  return response;
};

//get gigs in company profile

export const getCompanyGigsApi = async () => {
  const headers = await fetchToken();
  const response = await axios.get(`${getCompanyGigsUrl}`, {
    headers,
  });
  return response;
};

//Get Personal Details Location
export const getPersonalDetailsLocationApi = async (location, paramName = "location") => {
  const headers = await fetchToken();

  if (location == "") {
    return await axios.get(`${getPersonalDetailsLocationUrl}?${paramName}=`, {
      headers,
    });
  } else {
    return axios.get(`${getPersonalDetailsLocationUrl}?${paramName}=${location}`, {
      headers,
    });
  }
};

export const getExtTalLocationsApi = async (location) => {
  const headers = await fetchToken();
  return axios.get(`${getExtTalLocationsUrl}?location=${encodeURIComponent(location)}`, { headers });
};

export const getFiltersAPi = async () => {
  return null;
  return await axios.get(getFiltersUrl);
};

export const getKeywordSuggestionsApi = async (searchKey) => {
  const headers = await fetchToken();
  return await axios.get(`${getSearchSuggestionUrl}?${searchKey}`, { headers });
};

export const getSearchSuggestionsApi = async (params) => {
  const headers = await fetchToken();
  const type = params.obj.type.replace(/%20/g, " ");
  return await axios.get(
    `${getSearchSuggestionUrl}?search=${params.obj.search}&type=${type}`,
    { headers },
  );
};

export const getCompanyDetailsDropdownApi = async () => {
  const headers = await fetchToken();
  return await axios.get(`${getCompanyDetailsDropdownUrl}`, { headers });
};

export const postCompanyDetailsApi = async (data) => {
  const headers = await fetchToken();
  return await axios.put(postCompanyDetailsUrl, data, { headers });
};

export const updateCompanyDetailsApi = async (data) => {
  const headers = await fetchToken();
  return await axios.put(updateCompanyDetailsUrl, data, { headers });
};

export const verifyEmailApi = async (otp) => {
  const session = await Auth.currentSession();
  const token = session.getIdToken().getJwtToken();
  const headers = { authorization: token, "Content-Type": "application/json" };
  return await axios.put(verifyEmailUrl, { otp }, { headers });
};

export const fetchALLGigsApi = async (GigName) => {
  const headers = await fetchToken();
  return await axios.get(`${fetchAllGigsUrl}?gigName=${GigName}`, { headers });
};

export const getCulturePhotosApi = async (type) => {
  const headers = await fetchToken();
  return await axios.get(`${getCulturePhotosUrl}/${type.payload}`, { headers });
};

export const fetchViewsApi = async () => {
  const headers = await fetchToken();
  return await axios.get(`${fetchViewsUrl}`, { headers });
};

export const addMessageToFavouriteApi = async (request) => {
  const headers = await fetchToken();
  return await axios.post(`${AddMessageToFavouriteUrl}`, request.payload, {
    headers,
  });
};

export const removeMessageFromFavouriteApi = async (request) => {
  const headers = await fetchToken();
  // 63903c5d930d3500082d6e21
  // ${request.payload.SourceId}
  return await axios.put(
    `${removeMessageFromFavouriteUrl}/${request.payload.SourceId}`,
    request.payload,
    { headers },
  );
};

export const fetchFollowersApi = async () => {
  const headers = await fetchToken();
  return await axios.get(`${fetchFollowersUrl}`, { headers });
};

export const updateEmpProfileAlbumsApi = async (request) => {
  const data = JSON.stringify(request.payload);
  const headers = await fetchToken();
  return await axios.put(
    `${updateEmpProfileAlbumsUrl}/${request.payload.type}`,
    data,
    { headers },
  );
};

export const editEmpProfileAlbumsApi = async (request) => {
  // const data = JSON.stringify(request.payload.Picture);
  const data = JSON.stringify(request.payload);
  const headers = await fetchToken();
  return await axios.put(
    `${eidtEmpProfileAlbumsUrl}/${request.payload.type}/${request.payload.id}`,
    data,
    { headers },
  );
};

export const deleteEmpProfileAlbumsApi = async (request) => {
  const data = JSON.stringify(request.payload.Picture);
  const headers = await fetchToken();
  return await axios.put(
    `${deleteEmpProfileAlbumsUrl}/${request.payload.type}`,
    data,
    { headers },
  );
};

export const getEmpProfileAlbumsApi = async (request) => {
  // const data = JSON.stringify(request.payload);
  const headers = await fetchToken();
  return await axios.get(`${getEmpProfileAlbumsUrl}/${request.payload.type}`, {
    headers,
  });
};

//Post Gig Api
export const createGigApi = async (request) => {
  const data = JSON.stringify(request.payload);
  const headers = await fetchToken();
  return await axios.post(`${createGigUrl}`, data, { headers });
};
//Get gig title suggestions
export const getGigTitle = async (params) => {
  const headers = await fetchToken();
  return await axios.get(
    `${JobTitleUrl}?title=${params.title}&professionCode=${params.professionCode}`,
    { headers },
  );
};

export const getHRMDetails = async (params) => {
  try {
    const headers = await fetchToken();
    return await axios.get(
      `${getHRMDetailsAPI}`,
      // ?page=${params?.page || 1}&limit=${
      //   params?.limit || 10
      // }&search=${params?.search || undefined}&absAccountId=${
      //   params?.absAccountId || undefined
      // }`,
      { headers, params },
    );
  } catch (error) {}
};

export const getABSDetails = async (params) => {
  try {
    const headers = await fetchToken();
    return await axios.get(`${getABSDetailsAPI}`, { headers, params });
  } catch (error) {}
};
//Get Skills Api
export const getSearchSkillsApi = async (params) => {
  const headers = await fetchToken();
  let query = params.payload.search;
  if (query.includes("#")) {
    params.payload.search.replace("#", "%23");
  }
  if (query.includes("+")) {
    params.payload.search.replace("+", ""); //will check in future
  }
  return await axios.get(
    `${getSearchSkillsUrl}/?skillName=${params.payload.search.replace(
      "#",
      "%23",
    )}&SkillCategoryId=${params.payload.id}`,
    { headers },
  );
};

//Update Gig Api
export const updateGigApi = async (request) => {
  try {
    let data = request;
    if (request?.Location == null) {
      data = { ...request, Regions: null, Cities: null, Countries: null };
    }
    const headers = await fetchToken();
    return await axios.put(`${updateGigUrl}/${request.id}`, data, {
      headers,
    });
  } catch (err) {
    console.warn("Error : ", err);
  }
};
//update proposal api
export const updateProposalApi = async (request) => {
  const headers = await fetchToken();
  return await axios.put(
    `${updateProposalUrl}/${request.payload.id}`,
    request.payload,
    {
      headers,
    },
  );
};

//get user skill listing
export const getUserSkillListingApi = async (id) => {
  const headers = await fetchToken();
  return await axios.get(
    `${userSkillListing}?type=Published&userId=${id.payload}`,
    { headers },
  );
};

//skillListing Counts api

export const skillListingCountSagaApi = async (params) => {
  // const headers = await fetchToken();
  // const obj = params.params.obj
  //   ? { ...params.params.obj, CityId: [], RegionId: [], CountryId: [] }
  //   : params.params;
  // return await axios.put(`${SkillListingCount}`, { obj }, { headers });
  return null;
};

// skill listing total count

export const skillListingTotalCountApi = async (params) => {
  // const headers = await fetchToken();

  // return await axios.put(`${SkillListingTotalCount}`, params.params, {
  //   headers,
  // });
  return null;
};

//GET ALL JOBS
export const getJobListingApi = async (request) => {
  const headers = await fetchToken();
  if (request.payload.inputSearch) {
    return await axios.get(
      `${getJobListingUrl}/${request.payload.inputSearch}/${
        request.payload.currentPage
      }/${request.payload.pageSize}?sorttype=${
        request.payload.sorttype
      }&gigtype=${request.payload.gigType}&isPrivate=${
        request?.payload?.isPrivate ? request?.payload?.isPrivate : false
      }`,
      { headers },
    );
  } else if (request.payload.gigType) {
    return await axios.get(
      `${getJobListingUrl}/$/${request.payload.currentPage}/${
        request.payload.pageSize
      }?sorttype=${request.payload.sorttype}&gigtype=${
        request.payload.gigType
      }&isPrivate=${request.payload.sorttype}&gigtype=${
        request.payload.gigType
      }&isPrivate=${
        request?.payload?.isPrivate ? request?.payload?.isPrivate : false
      }`,
      { headers },
    );
  } else {
    return await axios.get(
      `${getJobListingUrl}/$/${request.payload.currentPage}/${
        request.payload.pageSize
      }?sorttype=${request.payload.sorttype}&isPrivate=${
        request.payload.sorttype
      }&gigtype=${request.payload.gigType}&isPrivate=${
        request?.payload?.isPrivate ? request?.payload?.isPrivate : false
      }`,
      { headers },
    );
  }
};

export const getJobListingResultApi = async (request) => {
  const headers = await fetchToken();
  if (request.payload.gigType) {
    return await axios.get(
      `${getJobListingUrl}/$/${request.payload.currentPage}/${request.payload.pageSize}?sorttype=${request.payload.sorttype}&gigtype=${request.payload.gigType}`,
      { headers },
    );
  }
};

export const getJobCountsApi = async (request) => {
  const headers = await fetchToken();

  try {
    return false;
    const {
      countries,
      cities,
      regions,
      all,
      search,
      _sort = "MOST_RECENT",
      MygigsProfileId,
      explevel,
      Skills,
      JobOrderTypeName,
      isPrivateGig = false,
      JobOrderStatusName = "All",
    } = request?.payload?.body;

    return await axios.put(
      getJobCountsUrl,
      {
        obj: {
          countries: countries?.length ? countries : undefined,
          cities: cities?.length ? cities : undefined,
          regions: regions?.length ? regions : undefined,
          all: all || search || "",
          _sort,
          MygigsProfileId,
          Skills: Skills?.length ? Skills : undefined,
          explevel: explevel || undefined,
          JobOrderTypeName: JobOrderTypeName || undefined,
          isPrivateGig,
          JobOrderStatusName,
        },
      },
      { headers },
    );
  } catch (error) {
    console.warn("Error : ", error);
  }
};
export const getCandidateCountsApi = async (request) => {
  // const headers = await fetchToken();

  try {
    // return await axios.put(getCandidateCountsUrl, request?.payload || {}, {
    //   headers,
    // });
    return null;
  } catch (error) {
    console.warn("Error : ", error);
  }
};

export const getJobListingDraftApi = async (request) => {
  const headers = await fetchToken();
  if (request.payload.inputSearch) {
    return await axios.get(
      `${getJobListingDraftUrl}/${request.payload.inputSearch}/${request.payload.currentPage}/${request.payload.pageSize}?sorttype=${request.payload.sorttype}`,
      { headers },
    );
  } else {
    return await axios.get(
      `${getJobListingDraftUrl}/$/${request.payload.currentPage}/${request.payload.pageSize}?sorttype=${request.payload.sorttype}`,
      { headers },
    );
  }
};

export const getRecentJobListingApi = async (request) => {
  const headers = await fetchToken();
  return await axios.get(`${getRecentJobListingUrl}/${request.payload}`, {
    headers,
  });
};

export const downloadSelectedDocumentsApi = async (payload) => {
  const headers = await fetchToken();
  return await axios.post(downloadSelectedDocumentsUrl, payload, { headers });
};

export const getDocumentViewUrlApi = async (documentId, userId) => {
  const headers = await fetchToken();
  return await axios.get(
    `${BackendApiBaseUrl}/documents/${encodeURIComponent(documentId)}/view-url?userId=${encodeURIComponent(userId)}`,
    { headers }
  );
};

export const getPerUserSkillListingApi = async (id) => {
  const headers = await fetchToken();
  if (id.jobId) {
    return await axios.get(
      `${perUserSkillListing}/${id.skillId}?jobId=${id.jobId}`,
      { headers },
    );
  } else {
    return await axios.get(
      `${perUserSkillListing}/${id.skillId}?type=skillListing`,
      { headers },
    );
  }
};

export const getGuestUserSkillListingApi = async ({ skillId }) => {
  return await axios.get(
    `${guestUserSkillListing}/${encodeURIComponent(skillId)}`,
  );
};

export const deleteJobApi = async (request) => {
  const headers = await fetchToken();
  return await axios.delete(`${deleteJobUrl}/${request.payload.id}`, {
    headers,
  });
};

export const getjobTemplatesApi = async (params) => {
  // let data = JSON.stringify(type)

  const headers = await fetchToken();
  return await axios.get(
    `${fetchjobTemplateUrl}?type=${params.type}&JobOrderTypeName=${params.JobOrderTypeName}`,
    { headers },
  );
};

export const getJobDetailApi = async (JobOrderId) => {
  const headers = await fetchToken();
  return axios.get(`${getJobDetailUrl}/${JobOrderId}`, { headers });
};

export const getJobBidDetailApi = async (JobOrderId) => {
  const headers = await fetchToken();
  return axios.get(`${getJobBidDetailUrl}/${JobOrderId}`, { headers });
};

// SEARCHSUGGESTION
export const fetchSearchSuggestionsAPI = async (value) => {
  const headers = await fetchToken();
  const fetchSuggestionAPI = `${BackendApiBaseUrl}/search?search=${value.payload.obj.search}&type=${value.payload.obj.type}`;
  const response = await axios.get(fetchSuggestionAPI, { headers });
  return response;
};

export const getUserDashboardApi = async () => {
  const headers = await fetchToken();
  return await axios.get(`${fetchdashboardUrl}`, { headers });
};

export const getUserDashboardInterviewApi = async () => {
  const headers = await fetchToken();
  return await axios.get(`${fetchdashboardInterviewUrl}`, { headers });
};

export const getUserDashboardMatchesApi = async () => {
  const headers = await fetchToken();
  return await axios.get(`${fetchdashboardMatchesUrl}`, { headers });
};

export const getGigRoleApi = async () => {
  const headers = await fetchToken();
  return await axios.get(`${BackendApiBaseUrl}/empgigs/getgigroles`, {
    headers,
  });
};

export const getRatingApi = async (request) => {
  const headers = await fetchToken();
  return await axios.get(`${getRatingUrl}/${request.id}?type=${request.type}`, {
    headers,
  });
};

//get Resume3d
export const getResume3dApi = async (id) => {
  const headers = await fetchToken();
  return await axios.get(`${getResume3dUrl}/${id}`, { headers });
};

//follow
export const followApi = async (request) => {
  const data = JSON.stringify(request.payload);
  const headers = await fetchToken();
  return await axios.post(`${followUrl}`, data, { headers });
};

//unfollow
export const unFollowApi = async (request) => {
  const data = JSON.stringify(request.payload.id);
  const headers = await fetchToken();

  return await axios.delete(`${unFollowUrl}/${request.payload.FollowerId}`, {
    headers,
  });
};

// get matched skills
export const getMatchedSkillsApi = async (gigid) => {
  const headers = await fetchToken();
  return await axios.get(`${getMatchedSkillsUrl}/${gigid}`, { headers });
};

export const getInvitedTalentsByJobApi = async ({
  jobId,
  skip = 0,
  limit = 10,
  matchesSkip = 0,
  matchesLimit = 0,
  sorttype,
}) => {
  const headers = await fetchToken();
  return await axios.get(
    `${getMatchedSkillsUrl}/${jobId}?skip=${skip}&limit=${limit}&matchesSkip=${matchesSkip}&matchesLimit=${matchesLimit}${
      sorttype ? `&sorttype=${sorttype}` : ""
    }`,
    { headers },
  );
};

export const getAllInterviewsApi = async () => {
  const headers = await fetchToken();
  return await axios.get(`${getAllInterviewsUrl}`, { headers });
};

// add to favourites
export const postFavoritesApi = async (SourceId) => {
  // let data = JSON.stringify(params);
  const headers = await fetchToken();
  return await axios.post(`${postFavoriteUrl}`, { SourceId }, { headers });
};

// delete from favourites
export const deleteFavoritesApi = async (SourceId) => {
  const headers = await fetchToken();
  const response = await axios.put(
    `${deleteFavoriteUrl}/${SourceId}`,
    {},
    {
      headers,
    },
  );

  return response;
};

// get favourites
export const getUserFavoritesApi = async (currentPage, pageSize, type) => {
  const headers = await fetchToken();
  return await axios.get(
    // `${fetchFavoritesUrl}/favorites/get?type=mobile=${currentPage}&perPage=${pageSize}`,
    // const fetchFavoritesUrl = `${BackendApiBaseUrl}/empprofile/favorites/get?type=web&page=1&perPage=`;
    `${fetchFavoritesUrl}?type=${type}&page=${currentPage}&perPage=${pageSize}`,
    { headers },
  );
};

export const addToMatchesApi = async (payload) => {
  const headers = await fetchToken();
  return await axios.post(`${addToMatchUrl}`, payload, { headers });
};
export const addSingleMatchesApi = async (payload) => {
  const headers = await fetchToken();
  return await axios.post(`${addToMatchUrl}`, payload, { headers });
};
export const addBatchMatchesApi = async (payload) => {
  const headers = await fetchToken();
  return await axios.post(`${batchMatchUrl}`, payload, { headers });
};

export const removeFromMatchesApi = async (params) => {
  const headers = await fetchToken();
  return await axios.delete(
    `${removeFromMatchUrl}/${params.SkillListingId}/${params.GigId}`,
    { headers },
  );
};

export const getTimeSheetListApi = async (payload) => {
  try {
    const {
      timesheetId = "",
      startDate = "2025-07-01",
      endDate = "2025-08-01",
      page = 1,
      limit = 10,
    } = payload;
    const headers = await fetchToken();
    return await axios.get(getTimeSheetListUrl, {
      headers,
      params: { timesheetId, startDate, endDate, page, limit },
    });
  } catch (error) {}
};

export const ApproveAllTimesheetAPI = async (params) => {
  const headers = await fetchToken();
  return await axios.put(`${approveAllTimesheetUrl}`, params, { headers });
};

export const editTimesheetAPI = async (params) => {
  const headers = await fetchToken();
  return await axios.put(`${editTimesheetUrl}`, params, { headers });
};

export const ApproveTimesheetAPI = async (params) => {
  const headers = await fetchToken();
  return await axios.put(`${approveTimesheetUrl}`, params, { headers });
};

export const ApproveTimeOffAPI = async (params) => {
  const headers = await fetchToken();
  return await axios.put(`${approveTimeOffUrl}`, params, { headers });
};

export const RejectTimesheetAPI = async (params) => {
  const headers = await fetchToken();
  return await axios.put(`${approveTimesheetUrl}`, params, { headers });
};
export const RejectTimeOffAPI = async (params) => {
  const headers = await fetchToken();
  return await axios.put(`${approveTimeOffUrl}`, params, { headers });
};

export const getNotificationApi = async (request) => {
  const headers = await fetchToken();
  return await axios.get(
    `${notificationUrl}/?page=${
      request.payload?.currentPage ? request.payload.currentPage : 1
    }&perPage=${request?.payload?.getAll ? request?.payload?.pageSize : 10}`,
    { headers },
  );
};

export const getReadNotificationApi = async (NOTIFICATION_ID) => {
  const headers = await fetchToken();
  return await axios.put(
    `${readNotificationUrl}/${NOTIFICATION_ID}`,
    {},
    { headers },
  );
};

export const getTimesheetApi = async (userAssignmentId, startdate, enddate) => {
  const headers = await fetchToken();
  return await axios.get(
    `${getTimesheetUrl}/${userAssignmentId}/${startdate}/${enddate}`,
    { headers },
  );
};

export const getAllTeamMembersApi = async ({ payload }) => {
  const { page = 1, limit = 10, search = "" } = payload;
  const headers = await fetchToken();
  return await axios.get(
    `${getAllTeamMembersUrl}?pageNumber=${page}&pageSize=${limit}&search=${encodeURIComponent(search)}`,
    { headers },
  );
};

export const addTeamMembersApi = async (params) => {
  const headers = await fetchToken();
  const payload = pickPayloadKeys(params, ADD_TEAM_MEMBER_SCHEMA_KEYS);
  return await axios.post(`${addTeamMembersUrl}`, payload, { headers });
};

export const updateTeamMembersApi = async (inv_id, params) => {
  const headers = await fetchToken();
  return await axios.put(`${updateTeamMembersUrl}/${inv_id}`, params, {
    headers,
  });
};

export const changeTeamMemberPasswordApi = async (invitationId, params) => {
  const headers = await fetchToken();
  return await axios.put(`${changeTeamMemberPasswordUrl}/${invitationId}`, params, {
    headers,
  });
};

export const deleteTeamMemberApi = async (member_id) => {
  const headers = await fetchToken();
  return await axios.delete(`${deleteTeamMemberUrl}/${member_id}`, { headers });
};

export const reactivateTeamMemberApi = async (member_id) => {
  const headers = await fetchToken();
  return await axios.put(
    `${reactivateTeamMemberUrl}/${member_id}`,
    {},
    { headers },
  );
};

//My Matches Api
export const getMatchesApi = async (request) => {
  const headers = await fetchToken();
  return await axios.get(
    `${getMatchesUrl}/${request.payload.currentPage}/${request.payload.pageSize}/?sorttype=${request.payload.sorttype}`,
    { headers },
  );
};

// My matches sort
export const getMatchesSortApi = async (request) => {
  const headers = await fetchToken();
  return await axios.get(
    `${getMyMatchesUrl}/1/12/?sorttype=${request.payload.sorttype}`,
    { headers },
  );
};

export const getGraphDetailsApi = async (payload) => {
  const headers = await fetchToken();
  return await axios.get(
    `${getGraphDetailsUrl}/${payload.userAssignmentId}/${payload.type}/${payload.startdate}/${payload.enddate}`,
    { headers },
  );
};

//get all payments
export const getAllPaymentsApi = async (payload) => {
  const headers = await fetchToken();
  return axios.get(
    `${getAllPaymentsUrl}/${payload.type}/${payload.start}/${payload.end}`,
    { headers },
    // `${getAllPaymentsUrl}/${payload.type}/null/null`,{ headers }
  );
};

// get candidates
export const getCandidatesApi = async (params) => {
  const headers = await fetchToken();
  return axios.get(
    `${candidatesUrl}/${params.payload?.bid_type_name}/${
      params?.payload?.bid_status_name
    }?startDate=${params.payload.startdate}&endDate=${
      params.payload.enddate
    }&page=${params.payload.page}&perPage=${params.payload.perPage}${
      isNull(params?.payload?.ABSId) ? "" : `&ABSId=${params?.payload?.ABSId}`
    }${
      isNull(params?.payload?.id) ? "" : `&id=${params?.payload?.id}`
    }&searchTerm=${params.payload.searchTerm || ""}${
      params?.payload?.bidType == "private" ? "&bidType=private" : ""
    }&timeSheetType=${params.payload.timeSheetType || "all"}${
      isNull(params?.payload?.vmsTypes)
        ? ""
        : `&vmsTypes=${params?.payload?.vmsTypes}`
    }${
      isNull(params?.payload?.facilityTypes)
        ? ""
        : `&facilities=${params?.payload?.facilityTypes}`
    }`,
    { headers },
  );
};
// ABSId=${
//   params.payload.ABSId
// }
export const getCandidateCountApi = async (params) => {
  const headers = await fetchToken();
  return axios.get(
    `${getCandidateCountUrl}/${params.payload.bid_type_name}?${
      isNull(params?.payload?.ABSId) ? "" : `&ABSId=${params?.payload?.ABSId}`
    }${
      isNull(params?.payload?.id) ? "" : `&id=${params?.payload?.id}`
    }&startDate=${params.payload.startdate}&endDate=${
      params.payload.enddate
    }&searchTerm=${params.payload.searchTerm || ""}${
      params?.payload?.bidType == "private" ? "&bidType=private" : ""
    }&timeSheetType=${params.payload.timeSheetType || "all"}
    ${
      isNull(params?.payload?.vmsTypes)
        ? ""
        : `&vmsTypes=${params?.payload?.vmsTypes}`
    }${
      isNull(params?.payload?.facilityTypes)
        ? ""
        : `&facilities=${params?.payload?.facilityTypes}`
    }`,
    { headers },
  );
};

//Get recent Searches Api
export const getRecentSearchApi = async (params) => {
  const headers = await fetchToken();
  const response = await axios.get(`${recentSearchUrl}`, { headers });
  return response;
};

export const clearRecentSearchApi = async (params) => {
  const headers = await fetchToken();
  const response = await axios.get(`${clearRecentSearchUrl}`, { headers });
  return response;
};

export const getTrendingJobsApi = async (params) => {
  const headers = await fetchToken();
  const response = await axios.get(`${trendingJobsUrl}`, { headers });
  return response;
};

export const getMyMatches = async (request) => {
  const headers = await fetchToken();
  if (request.filters) {
    const response = await axios.get(
      `${findMyMatches}/${request.id}?hidePreviouslyViewed=${
        request?.filters?.hidePreviouslyViewed ?? false
      }${
        request?.filters?.Latitude
          ? "&Latitude=" + request?.filters?.Latitude
          : ""
      }${
        request?.filters?.Longitude
          ? "&Longitude=" + request?.filters?.Longitude
          : ""
      }${
        request.filters.skillListingType
          ? "&skillListingType=" + request?.filters?.skillListingType
          : ""
      }${
        request.filters.budgetType
          ? "&budgetType=" + request.filters.budgetType
          : ""
      }${
        request.filters.budgetMax
          ? "&budgetMax=" + request.filters.budgetMax
          : ""
      }${
        request.filters.budgetMin
          ? "&budgetMin=" + request.filters.budgetMin
          : ""
      }${request.filters.CityId ? "&CityId=" + request.filters.CityId : ""}${
        request.filters.RegionId ? "&RegionId=" + request.filters.RegionId : ""
      }${
        request.filters.experienceLevel
          ? "&experienceLevel=" + request.filters.experienceLevel
          : ""
      }${
        request.filters.sortType ? "&sortType=" + request.filters.sortType : ""
      }`,
      { headers },
    );
    return response;
  } else {
    const response = await axios.get(`${findMyMatches}/${request.id}`, {
      headers,
    });
    return response;
  }
};

export const getMatchesCountAPI = async (req) => {
  const headers = await fetchToken();
  const response = await axios.get(
    `${matchesCount}/${req.id}${req.filters ? req.filters : ""}`,
    { headers },
  );
  return response;
};

export const getMatchesPaginationAPI = async (req) => {
  const headers = await fetchToken();
  const response = await axios.get(
    `${matchesPagination}/${req.skip}/${req.limit}?hidePreviouslyViewed=${
      req.hideMatches ?? false
    }&sortType=${req?.matchesFilter}&skills=${req.HEADING}${
      req.filters?.length > 0 ? req.filters.replace("?", "&") : ""
    }`,
    { headers },
  );
  return response;
};

export const getMyABSAPI = async (page = 1, limit = 5) => {
  const headers = await fetchToken();
  const response = await axios.get(`${getABSurl}?page=${page}&limit=${limit}`, {
    headers,
  });
  return response;
};

export const getMsgsCountApi = async (params) => {
  const headers = await fetchToken();
  // if (params?.jobId) {
  //   return await axios.get(
  //     `${messagesCountUrl}/${params?.allBids}?type=emp&jobId=${params?.jobId}&jobType=${params.jobType}`,
  //     { headers }
  //   );
  // }
  // if (params.hrmId)
  //   return await axios.get(
  //     `${messagesCountUrl}/${
  //       params?.bidTypeRadioValue ?? "all_bids"
  //     }?type=emp&HRMid=${params?.hrmId ?? null}`,
  //     { headers }
  //   );

  // return await axios.get(
  //   `${messagesCountUrl}/${
  //     params?.bidTypeRadioValue ?? params ?? "all_bids"
  //   }?type=emp`,
  //   { headers }
  // );
};

export const postNotesApi = async (params) => {
  const headers = await fetchToken();
  const response = await axios.post(`${postNotesApiUrl}`, params, { headers });

  return response;
};

export const updateNotesApi = async (params) => {
  const headers = await fetchToken();
  const response = await axios.put(
    `${updateNotesApiUrl}/${params.noteId}`,
    params,
    { headers },
  );

  return response;
};

export const getNotesApi = async (params) => {
  const headers = await fetchToken();
  const response = await axios.get(`${getNotesApiUrl}/${params?.id}`, {
    headers,
  });

  return response;
};

export const deleteNotesApi = async (params) => {
  const headers = await fetchToken();
  const response = await axios.put(
    `${updateNotesApiUrl}/${params?.noteId}`,
    { noteId: params?.noteId, Status: "deleted" },
    { headers },
  );
  return response;
};

export const getRemindersApi = async () => {
  const headers = await fetchToken();
  const response = await axios.get(`${getRemindersUrl}`, { headers });
  return response;
};

export const getConversationIDApi = async (bidid) => {
  const headers = await fetchToken();
  const response = await axios.get(`${getCoversationIdURL}/${bidid}`, {
    headers,
  });
  return response;
};

// email verification API
export const sendEmailVerificationStatusAPI = async () => {
  const session = await Auth.currentSession();
  const token = session.getIdToken().getJwtToken();
  const headers = { authorization: token, "Content-Type": "application/json" };
  const response = await axios.post(`${sendEmailVerifyStatusURL}`, {}, { headers });
  return response;
};

export const addUpdateUserDeviceDeatils = async (data) => {
  const headers = await fetchToken();
  await axios.put(`${addUpdateUserDeviceDeatilsURL}`, data, { headers });
};

// My Gigs Filters

export const getMyGigFilters = async (value) => {
  return false;
  const headers = await fetchToken();
  const {
    countries,
    cities,
    regions,
    all,
    _sort = "MOST_RECENT",
    MygigsProfileId,
    explevel,
    Skills,
    JobOrderTypeName,
    isPrivateGig = false,
    JobOrderStatusName = "All",
  } = value?.payload?.body;
  return await axios.put(
    getMyGigFiltersUrl,
    {
      obj: {
        countries: countries?.length ? countries : undefined,
        cities: cities?.length ? cities : undefined,
        regions: regions?.length ? regions : undefined,
        all: all || "",
        _sort,
        MygigsProfileId,
        Skills: Skills?.length ? Skills : undefined,
        explevel: explevel || undefined,
        JobOrderTypeName: JobOrderTypeName || undefined,
        isPrivateGig,
        JobOrderStatusName,
      },
    },
    { headers },
  );
};

export const searchMyGigsLocationSuggestionsApi = async (value) => {
  let fetchLocationAPI;
  const headers = await fetchToken();
  if (value.payload.value == undefined || value.payload.value == "") {
    fetchLocationAPI = `${BackendApiBaseUrl}/guest/getGigsLocation`;
  } else {
    fetchLocationAPI = `${BackendApiBaseUrl}/guest/getGigsLocation?${value.payload.value}`;
  }

  const {
    countries,
    cities,
    regions,
    all,
    skills,
    _sort = "MOST_RECENT",
    MygigsProfileId,
    explevel,
    Skills,
    JobOrderTypeName,
    isPrivateGig = false,
    JobOrderStatusName = "All",
  } = value?.payload?.body;
  const response = await axios.put(
    fetchLocationAPI,
    {
      obj: {
        countries: countries?.length ? countries : undefined,
        cities: cities?.length ? cities : undefined,
        regions: regions?.length ? regions : undefined,
        all: all || "",
        MygigsProfileId,
        _sort,
        Skills: Skills?.length ? Skills : undefined,
        explevel: explevel || undefined,
        JobOrderTypeName: JobOrderTypeName || undefined,
        isPrivateGig,
        JobOrderStatusName,
      },
    },
    {
      headers,
    },
  );
  return response;
};

export const searchMyGigsSkillsApi = async (value) => {
  let fetchSkillsAPI;

  const headers = await fetchToken();
  if (value.payload.value == undefined || value.payload.value == "") {
    fetchSkillsAPI = `${BackendApiBaseUrl}/guest/getGigsSkills`;
  } else {
    fetchSkillsAPI = `${BackendApiBaseUrl}/guest/getGigsSkills?${value.payload.value}`;
  }
  const {
    countries,
    cities,
    regions,
    all,
    skills,
    _sort = "MOST_RECENT",
    MygigsProfileId,
    explevel,
    Skills,
    JobOrderTypeName,
    isPrivateGig = false,
    JobOrderStatusName = "All",
  } = value?.payload?.body;
  const response = await axios.put(
    fetchSkillsAPI,
    {
      obj: {
        countries: countries?.length ? countries : undefined,
        cities: cities?.length ? cities : undefined,
        regions: regions?.length ? regions : undefined,
        all: all || "",
        _sort,
        MygigsProfileId,
        explevel: explevel || undefined,
        JobOrderTypeName: JobOrderTypeName || undefined,
        isPrivateGig,
        JobOrderStatusName,
      },
    },
    {
      headers,
    },
  );
  return response;
};

export const removePrivateTalentAPI = async (payload) => {
  const headers = await fetchToken();
  const response = await axios.put(
    `${removePrivateTalent}/${payload?.id}/${payload?.absAccountId}`,
    "",
    {
      headers,
    },
  );
  return response;
};

export const userTrackingClickAPI = async (request) => {
  await axios.post(UserTrackingURL, request?.payload);
};

export const fetchCandidateSkillsApi = async (request) => {
  const categoryId = isHC(request.payload.profCode) ? 3 : 1;
  const response = await axios.get(
    `${getSkillsUrl}?skillName=${
      request.payload.val ? request.payload.val : request.payload
    }&SkillCategoryId=${categoryId}`,
  );
  return response;
};

export const candidateEmailExistApi = async (payload) => {
  const headers = await fetchToken();
  try {
    const response = await axios.post(
      `${checkEmailExistURL}`,
      { email: payload },
      { headers },
    );
    return response?.data;
  } catch (error) {
    return error.response.data;
  }
};

export const addCandidateProfileApi = async (payload) => {
  const headers = await fetchToken();
  try {
    const response = await axios.post(`${profileAddCandidateURL}`, payload, {
      headers,
    });
    return response;
  } catch (error) {
    console.warn(error);
    return error;
  }
};

export const getInvitedTalentApi = async (request) => {
  const headers = await fetchToken();
  try {
    const response = await axios.get(
      `${invitedTalentURL}/?searchTerm=${
        request.query ? request.query : ""
      }&page=${request?.page ? request?.page : 1}&limit=${
        request?.limit ? request?.limit : 24
      }`,
      { headers },
    );
    return response;
  } catch (error) {
    console.warn("error", error);
  }
};

export const getInviteTrackingInvitesApi = async (request) => {
  const headers = await fetchToken();
  try {
    const userProfile = JSON.parse(localStorage.getItem("userProfile") || "{}");
    const accountId =
      request?.accountId ||
      userProfile?.MasterAccountId ||
      userProfile?.AccountId;
    if (!accountId) return { data: { invites: [], totalCount: 0 } };
    const params = new URLSearchParams();
    params.append("page", request?.page ? request.page : 1);
    params.append("limit", request?.limit ? request.limit : 10);
    if (request?.search) params.append("search", request.search);
    if (request?.query) params.append("search", request.query);
    if (request?.status && request.status !== "all") {
      params.append("status", request.status);
    }
    const response = await axios.get(
      `${inviteTrackingInvitesURL}/invites?${params.toString()}`,
      { headers },
    );
    return response;
  } catch (error) {
    console.warn("error", error);
  }
};

export const getInviteTrackingInviteHistoryApi = async ({
  accountId,
  profileId,
  jobId,
}) => {
  const headers = await fetchToken();
  try {
    if (!accountId || !profileId || !jobId) return null;
    const response = await axios.get(
      `${inviteTrackingInvitesURL}/${accountId}/invites/${profileId}/${jobId}`,
      { headers },
    );
    return response;
  } catch (error) {
    console.warn("error", error);
  }
};

export const checkIsUniqueNumber = async (number = "") => {
  try {
    const headers = await fetchToken();
    const response = await axios.post(
      numberCheckURL,
      { mobileNumber: number },
      {
        headers,
      },
    );
    return response.data.data.isNotExists;
  } catch (error) {
    return false;
  }
};

export const createTimeSheetApi = async (payload) => {
  try {
    const headers = await fetchToken();
    const response = await axios.post(timeSheet, payload, {
      headers,
    });
    return response;
  } catch (error) {
    return false;
  }
};
export const updateConfigTimeSheetApi = async (payload) => {
  try {
    const headers = await fetchToken();
    const response = await axios.put(updateConfigTimeSheet, payload, {
      headers,
    });
    return response;
  } catch (error) {
    return false;
  }
};

export const checkGapAPI = async (request) => {
  const headers = await fetchToken();
  try {
    const response = await axios.get(
      `${checkGapURL}/?BidId=${request.BidId}&BidType=${request.BidType}`,
      { headers },
    );
    return response;
  } catch (error) {
    console.warn("error", error);
  }
};

export const getTimeOffListApi = async (payload) => {
  try {
    const {
      timesheetId = "",
      startDate = "2025-07-01",
      endDate = "2025-08-01",
      page = 1,
      limit = 10,
    } = payload;
    const headers = await fetchToken();
    return await axios.get(timeOffURL, {
      headers,
      params: {
        timeSheetId: timesheetId,
        fromDate: startDate,
        toDate: endDate,
        page,
        limit,
      },
    });
  } catch (error) {}
};

export const downloadFile = async ({
  timesheetId,
  startDate,
  endDate,
  timeZone,
}) => {
  try {
    const headers = await fetchToken();
    const response = await axios.get(downloadTimeSheetURL, {
      params: { timesheetId, startDate, endDate, timeZone },
      responseType: "blob",
      headers,
    });

    const blob = new Blob([response.data], {
      type: response.headers["content-type"],
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;

    // Optional: Set file name from content-disposition header
    const contentDisposition = response.headers["content-disposition"];
    let fileName = "timesheet-download";
    if (contentDisposition && contentDisposition.includes("filename=")) {
      fileName = contentDisposition.split("filename=")[1].replace(/["']/g, "");
    }

    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    alertNotification("success", "Successfully downloaded");
  } catch (error) {
    alertNotification("error", error?.message || error || "Error Downloading.");
    console.error("Download failed:", error);
  }
};

export const getConfigTimeSheetAPI = async (params) => {
  try {
    const headers = await fetchToken();
    return await axios.get(configedTimesheet, {
      headers,
      params,
    });
  } catch (error) {}
};
export const VmsFilterapi = async (params) => {
  console.log(params, "vms");
  try {
    const headers = await fetchToken();
    return await axios.get(VmsFilterUrl, {
      headers,
      params,
    });
  } catch (error) {}
};

export const getDashboardName = async () => {
  try {
    const headers = await fetchToken();
    return await axios.get(dashboardTagUrl, {
      headers,
    });
  } catch (error) {}
};
// QueryPage — External Talent search
export const searchExternalUsersAPI = async (payload) => {
  const headers = await fetchToken();
  const userLocationPayload = await getCurrentUserLocationPayload();
  const response = await axios.post(searchExternalUsersUrl, {
    ...(payload || {}),
    ...userLocationPayload,
  }, {
    headers,
  });
  return response;
};

export const nlSearchExternalAPI = async (payload) => {
  const headers = await fetchToken();
  const { query, page, ...filterFields } = payload;
  const response = await axios.post(
    nlSearchExternalUrl,
    { query, page: page || 1, ...filterFields },
    { headers }
  );
  return response;
};

export const purchasePlanAPI = async (payload) => {
  try {
    const headers = await fetchToken();
    const response = await axios.post(planPurchaseUrl, payload, { headers });
    return response;
  } catch (error) {
    throw error;
  }
};

// QueryPage — External Talent detail
export const fetchPlansAPI = async (params = {}) => {
  try {
    const headers = await fetchToken();
    const response = await axios.get(plansUrl, { headers, params });
    return response;
  } catch (error) {
    throw error;
  }
};

export const fetchCreditsBalanceAPI = async () => {
  try {
    const headers = await fetchToken();
    const response = await axios.get(creditsBalanceUrl, { headers });
    return response;
  } catch (error) {
    throw error;
  }
};

export const fetchCreditsBannerAPI = async () => {
  try {
    const headers = await fetchToken();
    const response = await axios.get(creditsBannerUrl, { headers });
    return response;
  } catch (error) {
    throw error;
  }
};

export const fetchCreditTransactionsAPI = async ({
  page = 1,
  limit = 25,
  transactionType,
} = {}) => {
  try {
    const headers = await fetchToken();
    const response = await axios.get(creditsTransactionsUrl, {
      headers,
      params: { page, limit, transactionType },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const createCreditsPortalSessionAPI = async (payload) => {
  try {
    const headers = await fetchToken();
    const response = await axios.post(creditsPortalSessionUrl, payload, {
      headers,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const fetchCreditsInvoicesAPI = async ({ limit = 10 } = {}) => {
  try {
    const headers = await fetchToken();
    const response = await axios.get(creditsInvoicesUrl, {
      headers,
      params: { limit },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const fetchCreditsInvoiceDetailAPI = async (id) => {
  try {
    const headers = await fetchToken();
    const response = await axios.get(`${creditsInvoicesUrl}/${id}`, {
      headers,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const getExternalUserDetailUrl = `${BackendApiBaseUrl}/profile/external_users`;
export const getExternalUserDetailAPI = async (id) => {
  const headers = await fetchToken();
  const response = await axios.get(`${getExternalUserDetailUrl}/${id}`, {
    headers,
  });
  return response;
};

export const fetchExternalContactAPI = async (id) => {
  try {
    const headers = await fetchToken()

    const response = await axios.get(
      `${fetchExternalContactUrl}/${id}?linkedin=true&email=true&phone=true`,
      { headers }
    )

    return response
  } catch (error) {
    console.error('Error fetching external contact:', error)
    throw error
  }
}

// QueryPage — Internal Talent (associated talents)
export const getAssociatedTalentsAPI = async (payload) => {
  const headers = await fetchToken();
  const authToken = store.getState().authReducer.user
    ? store.getState().authReducer.user.authToken || ""
    : "";
  const skillListingId = payload?.SkillListingId;
  const url = skillListingId
    ? `${getAssociatedTalentsUrl}/${skillListingId}`
    : getAssociatedTalentsUrl;
  const response = await axios.put(
    url,
    {
      ...(payload || {}),
      Authorization: authToken,
    },
    { headers },
  );
  return response;
};

// QueryPage — Marketplace Talent (GraphQL skilllisting search via axios)
export const searchSkillListingQueryAPI = async (payload) => {
  const headers = await fetchToken();
  const { search = "", page = 1, perPage = 4 } = payload || {};
  const authToken = store.getState().authReducer.user
    ? store.getState().authReducer.user.authToken || ""
    : "";
  const userProfile = JSON.parse(localStorage.getItem("userProfile") || "{}");
  const accountId = userProfile?.AccountId || null;
  const professionCode = userProfile?.Professions?.ProfessionCode || "HC";

  const query = `{
  skilllistings(
    _sort: MOST_RELEVANT
    _page: ${page}
    _perPage: ${perPage}
    accountId: ${accountId}
    AbsPrivateTalent: false
    GigType: "null"
    CityId: []
    RegionId: []
    SkillsId: []
    CountryId: []
    VisaStatusId: []
    IndustryName: []
    CompanyName: "null"
    search: "${search}"
    BudgetMin: "null"
    BudgetMax: "null"
    BudgetType: "null"
    Experience: []
    NearBy: "null"
    Latitude: "null"
    Longitude: "null"
    maxDistance: "50"
    hide: null
    skillsPercentages: null
    searchType: Skills
    Authorization: "${authToken}"
    ProfessionCode: "${professionCode}"
  ) {
    aggregate {
      count
      totalCount
      __typename
    }
    gigCount {
      title
      count
      __typename
    }
    experienceCount {
      title
      count
      __typename
    }
    data {
      SkillListingId
      Title
      Description
      MinimumBid
      CreatedBy
      ModifiedBy
      bidstatus
      prevviewed
      Rating
      Review
      TotalCount {
        count {
          total
          __typename
        }
        __typename
      }
      BudgetTypes {
        BudgetTypeName
        __typename
      }
      ClientRate
      JobOrderTypes {
        JobOrderTypeName
        __typename
      }
      explevel {
        ExperienceLevelName
        __typename
      }
      users {
        UserName
        EmailAddress
        MobilePhone
        EmployeeAssociation
        LastSuccessfulLoginDate
        LastLoginDate
        Profiles {
          FirstName
          LastName
          Rating
          Review
          PictureUrl
          LastLoginDate
          ExperienceLevels {
            ExperienceLevelName
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}`;

  const response = await axios.post(
    searchSkillListingQueryUrl,
    { variables: {}, query },
    { headers },
  );
  return response;
};

// QueryPage — Marketplace Talent (REST PUT pmt-talents-search)
export const searchPmtTalentsAPI = async (payload) => {
  const headers = await fetchToken();
  const {
    search = "",
    page = 1,
    limit,
    perPage,
    searchType = "Skills",
    skillName,
    sortBy = "Most Relevant",
    filters = {},
    aiSearch,
    usePmtTalentsSearch,
  } = payload || {};
  const userLocationPayload = usePmtTalentsSearch
    ? await getCurrentUserLocationPayload()
    : {};

  const body = {  
    search,
    searchType,
    ...(!aiSearch && { skillName: skillName || "" }),
    sortBy,
    page,
    limit: limit || perPage || 4,
    filters,
    ...(aiSearch && { aiSearch: true }),
    ...(usePmtTalentsSearch && userLocationPayload),
  };

  const response = await axios.put(
    usePmtTalentsSearch ? pmtTalentsSearchUrl : getAssociatedTalentsUrl,
    body,
    { headers }
  );
  return response;
};

export const nlSearchMarketplaceAPI = async (payload) => {
  const headers = await fetchToken();

  const response = await axios.post(
    aiSearchUrl,
    {
      q: payload.q,
      page: payload.page || 1,
      per_page: payload.perPage || 20,
    },
    {
      headers,
    }
  );

  return response;
};

export const FacilityFilterapi = async (payload) => {
  try {
    const headers = await fetchToken();
    const { vms, ...queryParams } = payload || {};

    Object.keys(queryParams).forEach(
      (key) => queryParams[key] === "" && delete queryParams[key],
    );
    const body = vms ? { obj: { vms } } : {};

    const response = await axios.put(FacilityNameUrl, body, {
      headers,
      params: queryParams,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const inviteExternalUserApi = async (payload, userId) => {
  try {
    const headers = await fetchToken();

    const body = {
      medium: payload?.medium,
      jobId: payload?.jobId,
      message: payload?.message,
      template: payload?.template,
      ...(payload?.email && { email: payload.email }),
      ...(payload?.sms && { sms: payload.sms }),
      ...(payload?.whatsapp && { whatsapp: payload.whatsapp }),
    };

    const response = await axios.post(
      `${inviteExternalUserUrl}/${userId}/invite`,
      body,
      {
        headers: {
          ...headers,
          "Content-Type": "application/json",
        },
      },
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const sendReminderApi = async (payload, userId) => {
  try {
    const headers = await fetchToken();

    const body = {
      medium: payload?.medium,
      jobId: payload?.jobId,
      message: payload?.message,
      template: payload?.template,
      ...(payload?.email && { email: payload.email }),
      ...(payload?.sms && { sms: payload.sms }),
      ...(payload?.whatsapp && { whatsapp: payload.whatsapp }),
    };

    const response = await axios.post(
      `
      ${inviteExternalUserUrl}/${userId}/invite/reminder`,
      body,
      {
        headers: {
          ...headers,
          "Content-Type": "application/json",
        },
      },
    );
    return response;
  } catch (error) {
    console.error(error, "error");
    throw error;
  }
};
export const triggerAfterUpload = async (s3key) => {
  try {
    const headers = await fetchToken();
     await axios.post(afterUploadTrigger, {s3key}, {
    headers,
  });
  } catch (error) {

  }

}

export const writeWithAiApi = async (data) => {
  const headers = await fetchToken();
  return await axios.post(writeWithAiUrl, data, { headers });
};

export const writeWithAiDescriptionApi = async (data) => {
  const headers = await fetchToken();
  return await axios.post(writeWithAiDescriptionUrl, data, { headers });
};

export const searchProfessionsApi = async (q) => {
  const headers = await fetchToken();
  return await axios.get(`${searchProfessionsUrl}?q=${encodeURIComponent(q)}`, { headers });
};

export const nlSearchWriteWithAiApi = async (titles) => {
  const headers = await fetchToken();
  return await axios.post(nlSearchWriteWithAiUrl, { titles }, { headers });
};

export const brandfetchSearchApi = async (query) => {
  const headers = await fetchToken();
  return await axios.get(`${brandfetchSearchUrl}?query=${encodeURIComponent(query)}`, { headers });
};

export const searchDepartmentsApi = async (params) => {
  const headers = await fetchToken();
  return await axios.get(`${searchDepartmentsUrl}`, {
    headers,
    params: { search: params.payload.search },
  });
};

export const searchTalentsApi = async (params) => {
  const headers = await fetchToken();
  return await axios.get(`${searchTalentsUrl}`, {
    headers,
    params: { page: 1, perPage: 50, search: params.payload.search },
  });
};

export const createProjectApi = async (params) => {
  const headers = await fetchToken();
  return await axios.post(`${createProjectUrl}`, params.payload, { headers });
};

export const fetchProjectsApi = async (params) => {
  const headers = await fetchToken();
  const filters = params?.payload?.filters || {};
  const queryParams = { Page: filters.page || 1, perPage: filters.perPage || 10 };
  if (filters.search) queryParams.search = filters.search;
  if (filters.status) queryParams.status = filters.status;
  if (filters.priority) queryParams.priority = filters.priority.toLowerCase();
  if (filters.departments) queryParams.departments = filters.departments;
  if (filters.managerAccountId) queryParams.managerAccountId = filters.managerAccountId;
  if (filters.startDate) queryParams.startDate = filters.startDate;
  if (filters.dueDate) queryParams.dueDate = filters.dueDate;
  return await axios.get(fetchProjectsUrl, { headers, params: queryParams });
};

export const fetchProjectDetailApi = async (params) => {
  const headers = await fetchToken();
  return await axios.get(`${fetchProjectsUrl}/${params.payload.id}`, { headers });
};

export const updateProjectApi = async (params) => {
  const headers = await fetchToken();
  return await axios.put(
    `${fetchProjectsUrl}/${params.payload.id}`,
    params.payload.projectData,
    { headers }
  );
};

export const fetchProjectHistoryApi = async (params) => {
  const headers = await fetchToken();
  return await axios.get(`${fetchProjectsUrl}/${params.payload.id}/history`, { headers });
};

export const addProjectManagersApi = async (params) => {
  const headers = await fetchToken();
  return await axios.put(
    `${fetchProjectsUrl}/${params.payload.projectId}/team/managers`,
    { ManagerAccountIds: params.payload.accountIds },
    { headers }
  );
};

export const PROJECT_STATUS = {
  NEW: "new",
  IN_PROGRESS: "in_progress",
  ON_HOLD: "on_hold",
  COMPLETED: "completed",
  OVERDUE: "overdue",
  DRAFT: "draft",
  CANCELLED: "cancelled",
};

export const updateProjectStatusApi = async (params) => {
  const headers = await fetchToken();
  return await axios.put(
    `${fetchProjectsUrl}/${params.payload.id}/status`,
    { Status: params.payload.status },
    { headers }
  );
};

const timezonesUrl = `${BackendApiBaseUrl}/empprofile/timezones`;

export const fetchTimezonesApi = async ({ page = 1, limit = 500, search = "", country = "" } = {}) => {
  const headers = await fetchToken();
  const params = new URLSearchParams({ page, limit });
  if (search) params.set("search", search);
  if (country) params.set("country", country);
  return await axios.get(`${timezonesUrl}?${params.toString()}`, { headers });
};


export const fetchCurrenciesApi = async ({ search = "", page = 1, limit = 10 } = {}) => {
  const params = new URLSearchParams({ page, limit });
  if (search) params.set("search", search);
  return await axios.get(`${currenciesUrl}?${params.toString()}`);
};

export const postJobMessageApi = async (jobOrderId, externalTalentProfileId) => {
  const headers = await fetchToken();
  return await axios.post(`${BackendApiBaseUrl}/gigs/job-message`, { jobOrderId, externalTalentProfileId }, { headers });
};
